<template>
<div v-if="inputValue && spans">
<v-form v-model="isFormValid">

  <div class="my-8">
    <h5>{{ $t('nurseryHours.extendedPatternName') }}</h5>
    <v-text-field
      v-model="inputValue.patternTitle"
      variant="outlined"
      hide-details
      density="compact"
    ></v-text-field>
  </div>

  <div class="my-6 d-flex justify-center">
    <v-img
      src="@/assets/entyo_zuhyo2.png"
      contain
      height="40vh"
    ></v-img>
  </div>

  <!-- 固定時間枠（保育園） -->
  <div class="menu-header">{{ $t('nurseryHours.regularCare') }}</div>
  <div class="my-8">
    <h5>{{ $t('nurseryHours.regularCareStartTime') }}</h5>
    <time-input
      :hour="inputValue.normalChildcareStartingHour"
      @hour="inputValue.normalChildcareStartingHour = Number($event)"
      :minute="inputValue.normalChildcareStartingMinute"
      @minute="inputValue.normalChildcareStartingMinute = Number($event)"
    >
    </time-input>
  </div>

  <div class="my-8">
    <h5>{{ $t('nurseryHours.groupFixedRate') }}</h5>
    <div class="d-flex">
      <v-checkbox
        v-model="inputValue.isGroupFixed"
        :label="$t('nurseryHours.applyGroupFixedRate')"
      ></v-checkbox>
    </div>
    <div class="d-flex">
      <div>
        <h5>{{ $t('nurseryHours.regularCare') }}</h5>
        <v-text-field
          v-model="inputValue.groupFixedBillingFee.normalChildcareBillingAmount"
          :rules="[isSafeInteger, isNotMinus]"
          class="pr-2"
          variant="outlined"
          filled
          hide-details
          density="compact"
          suffix="円"
          style="width:200px;"
        ></v-text-field>
      </div>
      <div>
        <h5>{{ $t('nurseryHours.shortenedCare') }}</h5>
        <v-text-field
          v-model="inputValue.groupFixedBillingFee.shortenedChildcareBillingAmount"
          :rules="[isSafeInteger, isNotMinus]"
          class="pl-2"
          variant="outlined"
          filled
          hide-details
          density="compact"
          suffix="円"
          style="width:200px;"
        ></v-text-field>
      </div>
    </div>
  </div>

  <div class="my-8">
    <h5>-{{ $t('nurseryHours.earlyMorningExtension') }}</h5>
    <billing-input
      :billingMethod="inputValue.earlyHoursBillingFee.billingMethod"
      @billingMethod="inputValue.earlyHoursBillingFee.billingMethod = $event"
      :hourly="inputValue.earlyHoursBillingFee.hourly"
      @hourly="inputValue.earlyHoursBillingFee.hourly = $event"
      :monthly="inputValue.earlyHoursBillingFee.monthly"
      @monthly="inputValue.earlyHoursBillingFee.monthly = $event"
    ></billing-input>
  </div>

  <div class="menu-header">{{ $t('nurseryHours.shortenedCare') }}</div>
  <div class="my-8">
    <h5>{{ $t('nurseryHours.shortenedCareStartTime') }}</h5>
    <time-input
      :hour="inputValue.shortenedChildcareStartingHour"
      @hour="inputValue.shortenedChildcareStartingHour = Number($event)"
      :minute="inputValue.shortenedChildcareStartingMinute"
      @minute="inputValue.shortenedChildcareStartingMinute = Number($event)"
    ></time-input>
  </div>

  <div class="my-8">
    <h5>-{{ $t('nurseryHours.beforeShortenedCare') }}</h5>
    <billing-input
      :billingMethod="inputValue.shortenedBillingFee.before.billingMethod"
      @billingMethod="inputValue.shortenedBillingFee.before.billingMethod = $event"
      :hourly="inputValue.shortenedBillingFee.before.hourly"
      @hourly="inputValue.shortenedBillingFee.before.hourly = $event"
      :monthly="inputValue.shortenedBillingFee.before.monthly"
      @monthly="inputValue.shortenedBillingFee.before.monthly = $event"
    ></billing-input>
  </div>

  <div class="my-8">
    <h5>-{{ $t('nurseryHours.afterShortenedCare') }}</h5>
    <billing-input
      :billingMethod="inputValue.shortenedBillingFee.after.billingMethod"
      @billingMethod="inputValue.shortenedBillingFee.after.billingMethod = $event"
      :hourly="inputValue.shortenedBillingFee.after.hourly"
      @hourly="inputValue.shortenedBillingFee.after.hourly = $event"
      :monthly="inputValue.shortenedBillingFee.after.monthly"
      @monthly="inputValue.shortenedBillingFee.after.monthly = $event"
    ></billing-input>
  </div>

  <!-- 時間枠 -->
  <div v-for="(item, i) in spans.spans" :key="i">
    <div class="menu-header">{{ $t('nurseryHours.extendedCareN', { n: i+1 }) }}</div>

    <div class="my-8">
      <div>
        <h5>{{ $t('nurseryHours.startTime') }}</h5>
        <time-input
          :hour="item.startingHour"
          @hour="item.startingHour = Number($event)"
          :minute="item.startingMinute"
          @minute="item.startingMinute = Number($event)"
        ></time-input>
      </div>

      <div class="mt-4">
        <h5>{{ $t('nurseryHours.endTime') }}</h5>
        <time-input
          :hour="item.endingHour"
          @hour="item.endingHour = Number($event)"
          :minute="item.endingMinute"
          @minute="item.endingMinute = Number($event)"
        ></time-input>
      </div>

      <div class="my-8">
        <billing-input
          :billingMethod="item.billingMethod"
          @billingMethod="item.billingMethod = $event"
          :hourly="item.hourly"
          @hourly="item.hourly = $event"
          :monthly="item.monthly"
          @monthly="item.monthly = $event"
        ></billing-input>
      </div>
    </div>

  </div>

  <div class="d-flex">
    <v-btn
      @click="addSpanRow"
      color="primary"
      variant="outlined"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>

  <div class="my-12 d-flex justify-center">
    <v-btn
      @click="updatePattern"
      v-if="isUpdatable"
      :loading="isLoading"
      :disable="!isFormValid"
      color="primary"
      variant="flat"
      large
    >{{ $t('common.save') }}</v-btn>
    <v-btn
      @click="createPattern"
      v-else
      :loading="isLoading"
      :disable="!isFormValid"
      color="primary"
      variant="flat"
      large
    >{{ $t('common.create') }}</v-btn>
  </div>

</v-form>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TimeInput from '@/components/organisms/nursery-hours/TimeInput.vue'
import { CreateSpotNurseryInput, nurseryHoursModule, CreateSpansInput } from '@/store/dataModules/nurseryHoursModule';
import LocalDataService from '@/service/LocalDataService';
import BillingInput from '@/components/organisms/nursery-hours/BillingInput.vue';
import Swal from 'sweetalert2';
import ValidationMixin from '@/mixins/ValidationMixin';

export default defineComponent({
  name: 'SpotNurseryPatternContainer',

  mixins: [ValidationMixin],

  components: { TimeInput, BillingInput },

  mounted() {
    if (!this.isUpdatable) {
      this.initValues();
      this.initSpans();
      this.addSpanRow();
    }
  },

  data() {
    return {
      isLoading: false,
      isFormValid: false,
    }
  },

  computed: {
    inputValue: {
      get(): CreateSpotNurseryInput | null {
        return nurseryHoursModule.spotNurseryPatternInput;
      },
      set(value: CreateSpotNurseryInput) {
        nurseryHoursModule.setSpotNurseryPatternInput(value);
      }
    },
    isUpdatable: function(): boolean {
      return (this.$route.query && this.$route.query.category != null); 
    },
    spans: {
      get(): CreateSpansInput | null {
        return nurseryHoursModule.spansInput;
      },
      set(value: CreateSpansInput) {
        nurseryHoursModule.setSpansInput(value);
      }
    },
  },

  methods: {
    initValues() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        this.inputValue = {
          nurseryId: nurseryId,
          patternTitle: this.$t('nurseryHours.defaultPatternTitle') as string,
          normalChildcareStartingHour: 8,
          normalChildcareStartingMinute: 0,
          shortenedChildcareStartingHour: 6,
          shortenedChildcareStartingMinute: 0,
          isGroupFixed: false,
          groupFixedBillingFee: {
            normalChildcareBillingAmount: 0,
            shortenedChildcareBillingAmount: 0,
          },
          earlyHoursBillingFee: {
            billingMethod: 'hourly',
            hourly: {
              billingMinute: 10,
              billingAmount: 100,
              billingUpperLimitAmount: undefined,
            },
            monthly: {
              billingAmount: 100,
            },
          },
          shortenedBillingFee: {
            before: {
              billingMethod: 'hourly',
              hourly: {
                billingMinute: 10,
                billingAmount: 100,
                billingUpperLimitAmount: undefined,
              },
              monthly: {
                billingAmount: 0,
              },
            },
            after: {
              billingMethod: 'hourly',
              hourly: {
                billingMinute: 10,
                billingAmount: 100,
                billingUpperLimitAmount: undefined,
              },
              monthly: {
                billingAmount: 100,
              },
            },
          },
        };
      }
    },
    async createPattern() {
      this.isLoading = true;
      const response = await nurseryHoursModule.createSpotNurseryPattern()
      .catch((e) => {
        alert(this.$t('ui.patternConfigFailed'));
      });
      if (response) {
        if (response.patternId) {
          await this.createSpans(response.patternId);
        }
        Swal.fire({
          title: this.$t('nurseryHours.createSuccess') as string,
        });
        this.$router.push({ path: '/nursery-hours' });
      }
      this.isLoading = false;
    },
    async updatePattern() {
      this.isLoading = true;
      const patternId = this.$route.query?.patternId;
      if (patternId) {
        const response = await nurseryHoursModule.updateSpotNurseryPattern({
          patternId: String(patternId),
        })
        .catch((e) => {
          alert(this.$t('ui.patternConfigFailed'));
        });
        if (response) {
          if (response.patternId) {
            await this.updateSpans(response.patternId);
          }
          Swal.fire({
            title: this.$t('nurseryHours.saveSuccess') as string,
          });
          this.$router.push({ path: '/nursery-hours' });
        }
      }
      this.isLoading = false;
    },
    async createSpans(patternId: string) {
      if (patternId && nurseryHoursModule.spansInput) {
        nurseryHoursModule.spansInput.patternId = patternId;
        await nurseryHoursModule.saveSpans()
        .catch((e) => {
          alert(this.$t('ui.invalidTimeFrame'));
        });
      }
    },
    async updateSpans(patternId: string) {
      if (patternId && nurseryHoursModule.spansInput) {
        nurseryHoursModule.spansInput.patternId = patternId;
        await nurseryHoursModule.updateSpans()
        .catch((e) => {
          alert(this.$t('ui.invalidTimeFrame'));
        });
      }
    },
    initSpans() {
      this.spans = {
        patternId: '0',
        spans: [],
        spanCategory: 'normal',
      }
    },
    addSpanRow() {
      this.spans?.spans.push({
        startingHour: 6,
        startingMinute: 0,
        endingHour: 6,
        endingMinute: 59,
        billingMethod: 'hourly',
        hourly: {
          billingMinute: 30,
          billingAmount: 100,
          billingUpperLimitAmount: undefined,
        },
        monthly: {
          billingAmount: 100,
        }
      });
    },
  },
})
</script>